import { NgModule, inject } from '@angular/core';

import { FuseSplashScreenService } from './splash-screen.service';
@NgModule({
  providers: [FuseSplashScreenService]
})
export class FuseSplashScreenModule {
  private __fuseSplashScreenService = inject(FuseSplashScreenService);
}
